"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var Opacity = {
	None: process.env.REACT_APP_Opacity_None,
	UltraDark: process.env.REACT_APP_Opacity_UltraDark,
	VeryDark: process.env.REACT_APP_Opacity_VeryDark,
	Darker: process.env.REACT_APP_Opacity_Darker,
	Dark: process.env.REACT_APP_Opacity_Dark,
	Medium: process.env.REACT_APP_Opacity_Medium,
	Light: process.env.REACT_APP_Opacity_Light,
	Lighter: process.env.REACT_APP_Opacity_Lighter,
	VeryLight: process.env.REACT_APP_Opacity_VeryLight,
	UltraLight: process.env.REACT_APP_Opacity_UltraLight,
	Full: process.env.REACT_APP_Opacity_Full
};

exports.default = Opacity;